import React, { useEffect, useState } from 'react'
import { Text, Text3 } from '../common'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import { Box, Stack, alpha } from '@mui/material'
import { getPublicAccount } from '@/api/orders'
import Modal2 from '@/components/Modal2'

interface PayeeModalProps {
  orderCode: string
  orderAmount: number
  open: boolean
  onCancel: () => void
}

const PayeeModal: React.FC<PayeeModalProps> = ({ open, onCancel, orderCode, orderAmount }) => {
  const [infoList, setInfoList] = useState([
    { label: '订单号', value: orderCode },
    { label: '公司名称', value: '' },
    {
      label: '开户银行',
      value: '',
    },
    { label: '银行账号', value: '' },
    { label: '汇款金额', value: orderAmount },
  ])
  useEffect(() => {
    if (orderCode) {
      getPublicAccount({ order_code: orderCode }).then((res) => {
        if (res) {
          setInfoList([
            { label: '订单号', value: orderCode },
            { label: '公司名称', value: res.company },
            { label: '开户银行', value: res.bank_name },
            { label: '银行账号', value: res.bank_account },
            { label: '汇款金额', value: orderAmount },
          ])
        }
      })
    }
  }, [orderCode])
  return (
    <Modal2
      title='查看收款信息'
      width={800}
      okText='关闭'
      showCancel={false}
      open={open}
      onCancel={onCancel}
      onOk={onCancel}
    >
      <Stack
        direction='row'
        gap={1}
        sx={(theme) => {
          return {
            py: 1,
            px: 2,
            color: 'error.main',
            backgroundColor: alpha(theme.palette.error.main, 0.1),
            fontSize: 14,
            alignItems: 'center',
            marginBottom: 2,
            borderRadius: 1,
          }
        }}
      >
        <InfoRoundedIcon sx={{ color: 'error.main', fontSize: 20 }} />
        <Box>请在对公汇款时务必备注订单号</Box>
      </Stack>
      <Stack gap={3} sx={{ backgroundColor: 'rgba(242, 243, 245, 0.5)', borderRadius: 1, p: 2 }}>
        {infoList.map((item, index) => (
          <Stack direction='row' gap={3} key={index}>
            <Text3 sx={{ width: 126, flexShrink: 0 }}>{item.label}</Text3>
            <Text sx={{ fontSize: 14 }}>{item.value}</Text>
          </Stack>
        ))}
      </Stack>
    </Modal2>
  )
}

export default PayeeModal
